import { CloseOutlined, RefreshOutlined } from "@mui/icons-material";
import { Box, Button, Card, IconButton, TextField } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import Flx from "../../layout/Flx";
import Txt from "../../typography/Txt";

const MermaidChartEditor = ({
  editedChart,
  setEditedChart,
  onReset,
  onApplyChanges,
  onClose,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        border: `2px solid ${blueGrey[100]}`,
        boxShadow: "none",
        flexGrow: 1,
        display: "flex",
        p: 0,
        flexDirection: "column",
        minHeight: 0, // critical
      }}
    >
      <Flx
        fw
        jb
        ac
        sx={{
          background: blueGrey[50],
          p: 2,
          flexShrink: 0,
        }}
      >
        <Txt bold>Code Editor</Txt>
        <Flx gap={1}>
          <Button
            size="small"
            variant="outlined"
            startIcon={<RefreshOutlined />}
            onClick={onReset}
          >
            Reset
          </Button>
          <Button size="small" variant="contained" onClick={onApplyChanges}>
            Apply Changes
          </Button>
          <IconButton onClick={onClose} size="small">
            <CloseOutlined fontSize="small" />
          </IconButton>
        </Flx>
      </Flx>

      <Box
        sx={{
          flex: 1,
          p: 2,
          minHeight: 0, // critical
          overflow: "hidden", // prevent parent from stealing scroll
          display: "flex",
        }}
      >
        <TextField
          fullWidth
          multiline
          rows={1} // ✅ IMPORTANT: prevents autosize from expanding forever
          value={editedChart}
          onChange={(e) => setEditedChart(e.target.value)}
          placeholder="Enter Mermaid syntax here..."
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",

            "& .MuiInputBase-root": {
              height: "100%",
              alignItems: "stretch",
            },

            // ✅ this is the actual <textarea>
            "& .MuiInputBase-inputMultiline": {
              height: "100% !important",
              overflowY: "auto",
              fontFamily: "monospace",
              fontSize: 13,
              lineHeight: 1.5,
            },
          }}
        />
      </Box>
    </Card>
  );
};

export default MermaidChartEditor;
